import { useSnackbar } from "notistack";
import { useMemo } from "react";

/** Toasts, so features do not each reach for notistack's API directly. */
export function useNotify() {
  const { enqueueSnackbar } = useSnackbar();
  return useMemo(
    () => ({
      success: (message: string) => enqueueSnackbar(message, { variant: "success" }),
      error: (message: string) => enqueueSnackbar(message, { variant: "error" }),
      info: (message: string) => enqueueSnackbar(message, { variant: "info" }),
    }),
    [enqueueSnackbar],
  );
}
